export default __webpack_public_path__ + "static/media/ApplesOrangesMockup1.0d195081.png";